import { CreateSmsTemplateMeta, CreateSmsTemplatePayload } from 'types/store/CreateSmsTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { createSmsTemplateActions } from '../actions';

export default createAsyncReducer<CreateSmsTemplateMeta, CreateSmsTemplatePayload>(createSmsTemplateActions);
